import { connect } from 'react-redux';
import getRx from '../../actions/userInformation/setRx';
import HomePageLayout from './HomePageLayout';

export default connect(null, {
  getRxConnect: getRx,
})(HomePageLayout);



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js